import { Saga } from './workers';

export default Saga;



// WEBPACK FOOTER //
// ./src/redux/blog/get-all/sagas.js